import React from 'react';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import { Tooltip } from 'components/Tooltip';
import { FormikField } from 'components/FormikField';

import { PropertySelectField } from '../PropertySelectField';

import styles from './AutoLayoutPaddingProperty.module.scss';

const _renderPaddingContent = ({
  value,
  iconName,
}: {
  value: any;
  iconName: any;
}) => (
  <>
    <Icon className={styles.icon} name={iconName} />
    <Typography
      className={styles.value}
      variant="body2"
      weight="medium"
      mode="compact"
    >
      {value}
    </Typography>
  </>
);

const AutoLayoutPaddingProperty = ({
  isInitialState,
  readOnly,
  designType,
  paddingLeftNamePrefix,
  paddingRightNamePrefix,
  paddingTopNamePrefix,
  paddingBottomNamePrefix,
  paddingLeftProperty,
  paddingRightProperty,
  paddingTopProperty,
  paddingBottomProperty,
  onChanged,
}: {
  isInitialState: any;
  readOnly: any;
  designType: any;
  paddingLeftNamePrefix: any;
  paddingRightNamePrefix: any;
  paddingTopNamePrefix: any;
  paddingBottomNamePrefix: any;
  paddingLeftProperty: any;
  paddingRightProperty: any;
  paddingTopProperty: any;
  paddingBottomProperty: any;
  onChanged: any;
}) => {
  if (isInitialState || designType === 'PROTOTYPE') {
    return (
      <div className={styles.properties}>
        <div className={styles.propertyReadOnly}>
          <Tooltip
            text="Left padding"
            triggerElement={_renderPaddingContent({
              value: paddingLeftProperty.value,
              iconName: 'paddingLeft',
            })}
          />

          <Tooltip
            text="Top padding"
            triggerElement={_renderPaddingContent({
              value: paddingTopProperty.value,
              iconName: 'paddingTop',
            })}
          />

          <Tooltip
            text="Right padding"
            triggerElement={_renderPaddingContent({
              value: paddingRightProperty.value,
              iconName: 'paddingRight',
            })}
          />

          <Tooltip
            text="Bottom padding"
            triggerElement={_renderPaddingContent({
              value: paddingBottomProperty.value,
              iconName: 'paddingBottom',
            })}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.properties}>
      <Tooltip
        text="Left padding"
        triggerElement={
          <FormikField
            name={paddingLeftNamePrefix}
            withControl={false}
            component={PropertySelectField}
            componentProps={{
              type: 'checkbox',
              readOnly,
              property: { value: paddingLeftProperty.value },
              renderProperty: ({ value }: { value: any }) =>
                _renderPaddingContent({ value, iconName: 'paddingLeft' }),
              onChanged,
            }}
          />
        }
      />

      <Tooltip
        text="Top padding"
        triggerElement={
          <FormikField
            name={paddingTopNamePrefix}
            withControl={false}
            component={PropertySelectField}
            componentProps={{
              type: 'checkbox',
              readOnly,
              property: { value: paddingTopProperty.value },
              renderProperty: ({ value }: { value: any }) =>
                _renderPaddingContent({ value, iconName: 'paddingTop' }),
              onChanged,
            }}
          />
        }
      />

      <Tooltip
        text="Right padding"
        triggerElement={
          <FormikField
            name={paddingRightNamePrefix}
            withControl={false}
            component={PropertySelectField}
            componentProps={{
              type: 'checkbox',
              readOnly,
              property: { value: paddingRightProperty.value },
              renderProperty: ({ value }: { value: any }) =>
                _renderPaddingContent({ value, iconName: 'paddingRight' }),
              onChanged,
            }}
          />
        }
      />

      <Tooltip
        text="Bottom padding"
        triggerElement={
          <FormikField
            name={paddingBottomNamePrefix}
            withControl={false}
            component={PropertySelectField}
            componentProps={{
              type: 'checkbox',
              readOnly,
              property: { value: paddingBottomProperty.value },
              renderProperty: ({ value }: { value: any }) =>
                _renderPaddingContent({ value, iconName: 'paddingBottom' }),
              onChanged,
            }}
          />
        }
      />
    </div>
  );
};

export default React.memo(AutoLayoutPaddingProperty) as any;
